// authentication
export const SIGN_IN_BY_PASSWORD = "SIGN_IN_BY_PASSWORD";
export const SIGN_IN_BY_TOKEN = "SIGN_IN_BY_TOKEN";
export const GET_TOKEN = "GET_TOKEN";
export const UPDATE_TOKEN_TIMER = "UPDATE_TOKEN_TIMER";
export const SIGN_OUT = "SIGN_OUT";

// creatives-upload
export const CREATE_CREATIVES = "CREATE_CREATIVES";
export const GET_MGID_TOKEN = "GET_MGID_TOKEN";
export const CREATE_CREATIVES_FOR_CAMPAIGN = "CREATE_CREATIVES_FOR_CAMPAIGN";
export const UPLOAD_FILES_TO_CDN = "UPLOAD_FILES_TO_CDN";
